import { render } from "./KeySettingsIcon.vue?vue&type=template&id=381de3d9"
import script from "./KeySettingsIcon.vue?vue&type=script&lang=js"
export * from "./KeySettingsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__